import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { ReferenceDataProvider } from './commons/reference-data-provider';
import { AppInsightsService } from './app-insights-service';
import { TimeoutService } from './schedule/services/timeout.service';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { filter, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { EventMessage, EventType } from '@azure/msal-browser';
import { environment } from 'src/environments/environment'; 

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  private readonly destroy$ = new Subject<void>();
  version = environment?.version ?? '0.0.0';

  constructor(
    private readonly referenceDataProvider: ReferenceDataProvider,
    private readonly appInsights: AppInsightsService,
    private readonly timeoutService: TimeoutService,
    private readonly msalService: MsalService,
    private readonly msalBroadcastService: MsalBroadcastService
  ) {}

  ngOnInit(): void {

     // start cache clearing based on the version
     const savedVersion = localStorage.getItem('appVersion');
    if (savedVersion !== this.version) {
      localStorage.setItem('appVersion', this.version);
      console.log(`New build version detected: ${this.version}`);
      window.location.replace(window.location.href); // Force reload to clear cache
    } else {
      console.log(`Current build version: ${this.version}`);
    }
    // end cache clearing based on the version

    this.referenceDataProvider.init();
    if (this.msalService.instance.getActiveAccount()) {
      this.startSessionMonitoring();
    }
    
    // Subscribe to login events to start monitoring when user logs in
    this.msalBroadcastService.msalSubject$
      .pipe(
        filter((msg: EventMessage) => msg.eventType === EventType.LOGIN_SUCCESS),
        takeUntil(this.destroy$)
      )
      .subscribe(() => {
        this.startSessionMonitoring();
      });
  }
  private startSessionMonitoring(): void {
    this.timeoutService.startMonitoring();
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
